import { Container, SizableText, SmartLink, XStack, shadowStandard } from '@my/ui'
import { OfferGridBlock } from './offer-grid.block'
import { SolitoImage } from 'solito/image'

export type OfferGridItemBlockProps = {
  imagePriority?: boolean
} & OfferGridBlock['offerGridOffers'][0]

export const OfferGridItem = (props: OfferGridItemBlockProps) => {
  return (
    <SmartLink
      Component={Container}
      borderRadius={12}
      overflow="hidden"
      width="auto"
      mr="$2"
      size="xl"
      href={`/discounts/${props.brand.slug}/${props.slug}`}
      {...shadowStandard}
    >
      {props.featuredImage && (
        <SolitoImage
          width={250}
          height={300}
          src={props.featuredImage.url}
          alt={props.featuredImage.alt || props.name}
          priority={props.imagePriority}
        />
      )}
      <XStack position="absolute" bottom={8} left={8} zIndex={100} flexWrap="wrap" width={180}>
        <SizableText color="$white" size="$7" fow="700">
          {props.name}
        </SizableText>
      </XStack>
    </SmartLink>
  )
}
